export function getPluralKey(n, key) {
  const abs = Math.abs(n) % 100;
  const last = abs % 10;

  let suffix;
  if (abs > 10 && abs < 20) {
    suffix = 5;
  } else if (last === 1) {
    suffix = 1;
  } else if (last >= 2 && last <= 4) {
    suffix = 2;
  } else {
    suffix = 5;
  }

  return `${key}.${suffix}`;
}
